import { preview } from '@/components/form/preview'
import { ConvertTime } from '@/components/smartUtils/conversion/ConvertTime'

import { useTexts } from '../useTexts'
import { NumberedLabel } from './NumberedLabel'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function CheckOut(props: Props) {
  const { extOrder } = props
  const texts = useTexts()

  const timeOutSec = extOrder.orderStep.trackingData?.timeOutSec ?? -1
  const timeOutDisabled = timeOutSec === -1

  return (
    <preview.Field
      label={
        <NumberedLabel
          number={2}
          label={texts.checkOut.label}
          color="#FF9800"
          disabled={timeOutDisabled}
        />
      }
      testId="execution-reported-check-out"
    >
      {timeOutSec > 0 ? (
        <ConvertTime seconds={timeOutSec} showSeconds={false} />
      ) : (
        <preview.NullValue />
      )}
    </preview.Field>
  )
}
